
import { WOW } from "wowjs";

/* eslint-disable-next-line */
(function ($, ajax_localize) {
	$(document).ready(function () {

		const wow = new WOW();

		wow.init();

		let headerScrollTopOffset = 0;

		if ($("body").hasClass("admin-bar") && ($(window).width() > 600)) {
			headerScrollTopOffset = $("html").css("margin-top");
		}

		// Set header navbar height
		$("body > header").css("--header-navbar-height", $("body > header").outerHeight() + "px");

		// Watch for when header is scrolled to or away from the top of the viewport
		// If header is scrolled to the top of the page, we know it's been stickied based on it having position: sticky
		// Add class when it's sitting at the top of the page, remove it when it's been scrolled away
		$("body > header").observeScrollTopChanges(headerScrollTopOffset).on("scroll-top-change", (evt) => {

			$(evt.target).toggleClass("sticky", evt.detail.scrolledToTop);

		});

		let desktopMenuBreakpoint = parseInt($(":root").css("--breakpoint-xl"));

		/**
		 * Header - Search bar functionality
		 */
		let searchButton 	= $( '.btn-search' );
		let closeButton 	= $( '#close-button' );
		let searchBar 		= $( '#search-container' );

		// Change placeholder
		searchBar.find( 'form input' ).attr( 'placeholder', 'What are you looking for?' );

		// Search click
		$.each( searchButton, function () {
			$( this ).on( 'click', function () {
				searchBar.fadeIn().addClass('show');
			});
		});

		// Close click
		closeButton.on( 'click', function () {
			searchBar.fadeOut().removeClass( 'show' );
		});

		/**
		 * Desktop menu dropdowns
		 */
		$(".menu-item-has-children").find(".dropdown-toggle").attr("data-toggle", "");

		$("#header-navbar-menu-wrapper").find(".menu-item.dropdown")
			.on("mouseenter", function(){

				fadeInMenuDropdown($(this).children(".dropdown-menu"));

			})
			.on("mouseleave", function(){

				fadeOutMenuDropdown($(this).children(".dropdown-menu"));

			});

		$("#header-navbar-menu-wrapper").find(".menu-item.dropdown > .nav-link")
			.on("focus", function(){

				fadeInMenuDropdown($(this).siblings(".dropdown-menu"));

			})
			.on("blur", function(){

				fadeOutMenuDropdown($(this).siblings(".dropdown-menu"));

			});


		/**
		 * Mobile menu
		 */

		$("header .js-mobile-menu-toggle").on("click", function(){

			$("body").addClass("no-scroll");

			$("#header-navbar-menu-wrapper").find(".primary-menu-wrap").addClass("curr-level");

			$("#header-navbar-menu-wrapper").fadeIn(300);

		});

		toggleHeaderMenuWrapperVisibility();

		let resizeThrottled = false;

		$(window).on("resize", function(){

			if(!resizeThrottled){

				toggleHeaderMenuWrapperVisibility();

				resizeThrottled = true;

				setTimeout(function(){

					resizeThrottled = false;

					toggleHeaderMenuWrapperVisibility();

				}, 250);

			}

		});

		$("#header-navbar-menu-wrapper")
			.find(".navbar-nav .menu-item.menu-item-has-children > .dropdown-menu").each(function(){

				if($(window).width() < desktopMenuBreakpoint){

					$(this).addClass("mobile-menu-sub-level-panel");

					let subLevelTitleElement =
						$("<a>")
							.addClass("nav-link")
							.attr("href", $(this).siblings(".nav-link").attr("href"))
							.html($(this).siblings(".nav-link").html().trim());

					$(this).prepend(
						$("<li>")
							.addClass("menu-item sub-level-panel-heading")
							.append(subLevelTitleElement)
					);

				}

			});

		$("#header-navbar-menu-wrapper")
			.find(".js-mobile-menu-close-trigger").on("click", function(){

				$("body").removeClass("no-scroll");

				$("#header-navbar-menu-wrapper").fadeOut(function(){

					$(this).find(".curr-level").removeClass("curr-level");

					$(this).find(".show").removeClass("show fade-in");

					$(this).find(".mobile-menu-sub-level-panel").scrollTop(0);

					$(this).find(".js-menu-back-btn").data("depth-level", 0);

				});

			});

		let mobileMenuBackBtnWrap = $("#header-navbar-menu-wrapper").find(".back-btn-wrap");
		let mobileMenuBackBtn = mobileMenuBackBtnWrap.children(".js-menu-back-btn");

		mobileMenuBackBtn.data("depth-level", 0);

		mobileMenuBackBtn.on("click", function(){

			$(this).data("depth-level", ($(this).data("depth-level") - 1));

			let currentMenuPanel = $("#header-navbar-menu-wrapper").find(".mobile-menu-sub-level-panel.curr-level");

			currentMenuPanel.parent().closest(".mobile-menu-sub-level-panel").addClass("curr-level");

			currentMenuPanel.addClass("fade-out").removeClass("show fade-in curr-level");

			if($(this).data("depth-level") <= 0){

				$("#header-navbar-menu-wrapper").find(".primary-menu-wrap").addClass("curr-level");

				$(this)
					.data("depth-level", 0)
					.parent()
					.addClass("fade-out")
					.removeClass("show fade-in");

			}

		});

		if (window.innerWidth < 1200) {
			$("#header-navbar-menu-wrapper").find(".navbar-nav .menu-item.menu-item-has-children > .nav-link")
				.on("click", function (evt) {

					evt.preventDefault();

					$("#header-navbar-menu-wrapper").find(".curr-level").removeClass("curr-level");

					let parentScrollOffset = $(this).closest(".mobile-menu-sub-level-panel, .primary-menu-wrap").scrollTop();

					$(this).siblings(".mobile-menu-sub-level-panel")
						.css("top", $(this).closest(".mobile-menu-sub-level-panel, .primary-menu-wrap").scrollTop())
						.scrollTop(0)
						.removeClass("fade-out")
						.addClass("show fade-in curr-level");

					if (mobileMenuBackBtn.data("depth-level") < 1) {

						mobileMenuBackBtnWrap
							.css("top", parentScrollOffset)
							.removeClass("fade-out")
							.addClass("show fade-in");

					}

					mobileMenuBackBtn.data("depth-level", (mobileMenuBackBtn.data("depth-level") + 1));

					return false;

				});
		}


		/**
		 * Back to top button - scroll functionality
		 */
		$("#back-to-top")
			.addClass("fade")
			.on("click", function(){
				$("html, body").animate({
					scrollTop: 0,
				}, 400);
			});

		$(window).scroll(function(){
			if ($(window).scrollTop() > 100){
				$("#back-to-top").addClass("show");
			} else {
				$("#back-to-top").removeClass("show");
			}
		});

		/**
		 * Form - Add custom checkbox element
		 */
		$( '.ginput_container_checkbox .gfield_checkbox .gchoice' ).addClass('checkbox_item').append('<div class="checkmark"></div>');

		/**
		 * Home - Add space between post block and centred content block
		 */
		let iconColHeight = $("body.home .posts-block .posts-container .posts-row .col").height();
		let contentBlock = $("body.home .posts-block + .centered-content-block");

		if(window.innerWidth >= 991) {
			contentBlock.css('padding-top', iconColHeight - 30);
		}

		/**
		 * Carousel - Set equal heights
		 */
		function carouselEqualHeights() {
			$('.carousel-block').each(function () {
				var items 		= $('.carousel-item', this);
				let maxHeight 	= 0;

				// Show all slides
				$.each( items, function( i, slide ) {
					$( slide ).addClass( 'active' );
				});

				// Get the height of the tallest caption and save it
				// Desktop
				if(window.innerWidth >= 993) {
					$.each( items, function() {
						let caption 		= $('.carousel-caption', this);
						let captionHeight 	= caption.outerHeight();

						if ( captionHeight > maxHeight ) {
							maxHeight = captionHeight;
						}
					});

					// Apply the max height to all captions
					$.each( items, function() {
						let caption = $(this);
						caption.css('height', maxHeight + 200);

						// Remove .active from all slides
						$( this ).removeClass( 'active' );
					});

				// Mobile
				} else {
					$.each( items, function() {
						let caption 		= $(this);
						let captionHeight 	= caption.css('height', 'auto').outerHeight();

						if ( captionHeight > maxHeight ) {
							maxHeight = captionHeight;
						}
					});

					// Apply the max height to all captions
					$.each( items, function() {
						let caption = $(this);
						caption.css('height', maxHeight);

						// Remove .active from all slides
						$( this ).removeClass( 'active' );
					});
				}

				// Add the active class back to the first slide
				$('.carousel-block .carousel-inner .carousel-item:first-of-type').addClass('active');
			});
		}

		// Run equal heights
		carouselEqualHeights();

		/**
		 * Testimonial - Set equal heights
		 */
		function testimonialEqualHeights() {
			$('.testimonial-block').each(function () {
				var items 		= $('.carousel-item', this);
				let maxHeight 	= 0;

				// Show all slides
				$.each( items, function( i, slide ) {
					$( slide ).addClass( 'active' );
				});

				// Get the height of the tallest caption and save it
				$.each(items, function () {
					let caption = $('.card', this);
					let captionHeight = caption.outerHeight();

					if (captionHeight > maxHeight) {
						maxHeight = captionHeight;
					}
				});

				// Apply the max height to all captions
				$.each(items, function () {
					let caption = $(this);
					caption.css('height', maxHeight);

					// Remove .active from all slides
					$(this).removeClass('active');
				});

				// Add the active class back to the first slide
				$('.testimonial-block .carousel-inner .carousel-item:first-of-type').addClass('active');
			});
		}

		// Run equal heights
		testimonialEqualHeights();

		/**
		 * Testimonial - Set equal heights
		 */
		function testimonialLargeEqualHeights() {
			$('.testimonial-large-block').each(function () {
				var items 		= $('.carousel-item', this);
				let maxHeight 	= 0;

				// Show all slides
				$.each( items, function( i, slide ) {
					$( slide ).addClass( 'active' );
				});

				// Get the height of the tallest caption and save it
				$.each(items, function () {
					let caption = $('.main', this);
					let captionHeight = caption.outerHeight();

					if (captionHeight > maxHeight) {
						maxHeight = captionHeight;
					}
				});

				// Apply the max height to all captions
				$.each(items, function () {
					let caption = $('.main', this);
					caption.css('height', maxHeight);

					// Remove .active from all slides
					$(this).removeClass('active');
				});

				// Add the active class back to the first slide
				$('.testimonial-large-block .carousel-inner .carousel-item:first-of-type').addClass('active');
			});
		}

		// Run equal heights
		testimonialLargeEqualHeights();

		function toggleHeaderMenuWrapperVisibility(){

			if(($(window).width() < desktopMenuBreakpoint)){

				if($("#header-navbar-menu-wrapper").css("--mobile-visible-display-val") !== ""){
					$("#header-navbar-menu-wrapper").css("display", $("#header-navbar-menu-wrapper").css("--mobile-visible-display-val"));
				}

				$("#header-navbar-menu-wrapper").hide();

			}else if($("#header-navbar-menu-wrapper").is(":hidden")){

				$("#header-navbar-menu-wrapper").css("display", "");

			}

		}

	});

	let fadeInMenuDropdown = function(dropdown){

		if($(window).width() >= parseInt($(":root").css("--breakpoint-xl"))){
			dropdown.removeClass("fade-out").addClass("fade-in");
		}

	};

	let fadeOutMenuDropdown = function(dropdown){

		if($(window).width() >= parseInt($(":root").css("--breakpoint-xl"))){
			dropdown.removeClass("fade-in").addClass("fade-out");
		}

	};

	// Fires event when element has scrolled up to or away from the top of it's parent
	$.fn.observeScrollTopChanges = function() {

		// Top and bottom margin values position marker element at the top of the box area of the current element, regardless of it's top margin
		// Need to increase bottom margin's negative value by 1px to compensate for marker's height
		// Essentially makes the marker invisible
		const marker = $("<div>").css({
			"margin-top":       this.css("marginTop"),
			"margin-bottom":    ((parseInt(this.css("marginTop")) + 1) * -1),
			"height":           "1px",
		});

		// Add to DOM before element being observed
		// When marker is hidden beyond the top of the viewport, the target element will be touching the top of the viewport
		this.before(marker);

		// Create observer object
		const scrollTopObserver = new IntersectionObserver((entries) => {

			// Width, height and scroll position of element being observed
			const targetBoundingRect = entries[0].boundingClientRect;
			// Width height and position of viewport
			const viewportBoundingRect = entries[0].rootBounds;

			// The element that should have the event triggered on it
			// Basically, the element that we want to know when it has reached the top of the page on scroll
			const evtTrigger = entries[0].target.nextSibling;

			let scrolledToTop = false;

			// If the entire marker element has scrolled beyond the top of the viewport
			if(targetBoundingRect.bottom < viewportBoundingRect.top){

				scrolledToTop = true;

				// If the entire marker element is visible again
			}else if(targetBoundingRect.bottom >= viewportBoundingRect.top){

				scrolledToTop = false;

			}

			// Create custom event and pass information about whether the element was just hit the top of the page or if it is being scrolled away
			const evt = new CustomEvent("scroll-top-change", {detail: {scrolledToTop: scrolledToTop}});

			evtTrigger.dispatchEvent(evt);

			// Threshold says how much of the element needs to be visible before checking for intersection
			// 0 means as soon as any part of the element is visible
		}, {threshold: [0]});

		// Start observing the marker element
		scrollTopObserver.observe(marker.get(0));

		// Return current element to allow for jQuery function chaining
		return this;

	};

/* eslint-disable-next-line */
})(jQuery, ajax_localize);